<template>
    <b-card header-tag="header" footer-tag="footer" class="w-100 h-100"
        header-class="d-flex justify-content-between border-bottom py-2 bg-white"
        body-class="w-100 bg-white overflow-hidden">
        <template #header>
            <h5 class="my-1">{{$t('CertificateList')}}</h5>
            <b-button @click="OnShowFaq" pill :variant="'outline-' + Variant">
                <b-icon-info-circle />
                {{$t('FAQ')}}
            </b-button>
        </template>
        <template #default>
            <!-- TABLEAU GENERIQUE POUR AFFICHAGE LISTE DES MANDATS -->
            <GenericTable 
                @ClickOnRowsEvent="OnSelect"
                :Variant="Variant" 
                :Headers="headers"
                :Rows="items"
                :EnableSelection="true"
                :SelectionType="selectionTypeEnum.Simple"
                :EnablePagination="true"
                :PerPage="10"
                :ShowDeleteButton="false"
                :ShowModifyButton="false"
                :ShowSearchField="true"
                :ShowColumnsSelector="false"
                :ShowToggleSelectionAll="false">
                <!-- BOUTON D'ARCHIVAGE MANDAT -->
                <template #column(Archive)="row">
                    <b-button 
                    v-if="row.row.Status == certificateStateEnum.SupervisorValidated && isSupervisor" 
                    @click="OnArchive(row.row)"
                    :title="$t('ArchiveCertificate')"
                    :variant="'outline-' + Variant" 
                    v-b-tooltip.html
                    class="btn-circle border-0">
                        <font-awesome-icon icon="fa-solid fa-box-archive" />
                    </b-button>
                    <b-button 
                    v-if="row.row.Status < certificateStateEnum.SupervisorValidated" 
                    @click="OnDelete(row.row)" 
                    v-b-tooltip.html
                    :title="$t('DeleteCertificate')"
                    :variant="'outline-' + Variant" 
                    class="btn-circle border-0">
                        <font-awesome-icon icon="fa-solid fa-xmark"/>
                    </b-button>
                </template>
                <!-- LOGO DISTRIBUTEUR -->
                <template #column(Distributor)="row">
                    <b-img
                        :src="getLogo(sMACertificateEnum[row.row.Distributor])"
                        :width="50" 
                        alt="Logo"
                        v-b-tooltip.html
                        :title="sMACertificateEnum[row.row.Distributor]"/>
                </template>
                <template #column(DateValidation)="row">
                    <div v-if="row.row.Status == certificateStateEnum.ClientValidated">
                        {{ formatDateFromString(row.row.DateCustomerValidation) }}
                    </div>
                    <div v-if="row.row.Status == certificateStateEnum.SupervisorValidated">
                        {{ formatDateFromString(row.row.DateSupervisorValidation) }}
                    </div>
                </template>
                <template #column(EndDate)="row">
                    {{ formatDate(row.row.EndDate) }}
                </template>
                <!-- STATUT DU MANDAT -->
                <template #column(Status)="row">
                    <b-badge pill class="py-1 px-2" :variant="statusVariant[row.row.Status]">
                        {{ $t(certificateStateEnum[row.row.Status]) }}
                    </b-badge>
                </template>
                <!-- BOUTONS D'ACTIONS SUR MANDAT -->
                <template #column(Action)="row">
                    <!-- BOUTON ROLLBACK MANDAT -->
                    <b-button 
                        v-if="row.row.Status == certificateStateEnum.ClientValidated && isSupervisor && hasClientSignature(row.row.Distributor)" 
                        @click="OnRollBack(row.row)" 
                        v-b-tooltip.html
                        :title="$t('RollBack')"
                        :variant="'outline-' + Variant" 
                        class="btn-circle border-0">
                        <font-awesome-icon icon="fa-solid fa-backward-step" />
                    </b-button>
                    <!-- BOUTON MODIFICATION MANDAT -->
                    <b-button 
                        v-if="row.row.Status == certificateStateEnum.Created"
                        @click="OnEdit(row.row)" 
                        v-b-tooltip.html
                        :title="$t('EditCertificate')"
                        :variant="'outline-' + Variant" 
                        class="btn-circle border-0">
                        <font-awesome-icon icon="fa-solid fa-pen" />
                    </b-button>
                    <!-- BOUTON SIGNATURE CLIENT -->
                    <b-button 
                        v-if="row.row.Status == certificateStateEnum.Created && hasClientSignature(row.row.Distributor)"
                        @click="OnClientValidation(row.row)" 
                        v-b-tooltip.html
                        :title="$t('ClientValidation')"
                        :variant="'outline-' + Variant" 
                        class="btn-circle border-0">
                        <font-awesome-icon icon="fa-solid fa-file-signature" />
                    </b-button>
                    <!-- BOUTON SIGNATURE SUPERVISEUR -->
                    <b-button 
                        v-if="isSupervisor && row.row.Status == supervisorValidationState(row.row.Distributor)"
                        @click="OnSupervisorValidation(row.row)" 
                        v-b-tooltip.html
                        :title="$t('SupervisorValidation')"
                        :variant="'outline-' + Variant" 
                        class="btn-circle border-0">
                        <font-awesome-icon icon="fa-solid fa-file-signature" />
                    </b-button>
                    <!-- BOUTON DONNEES TECHNIQUES COMPTEURS (SUPERVISEUR, MANDAT SIGNE) -->
                    <!-- Rouge si au moins un compteur du mandat n'a pas ses données techniques complètes -->
                    <b-button 
                        v-if="row.row.Status == certificateStateEnum.SupervisorValidated && isSupervisor && hasTechnicalData(row.row.Distributor)" 
                        @click="OnTechnicalData(row.row)" 
                        v-b-tooltip.html
                        :title="$t('EnterTechnicalData')"
                        :variant="hasMissingTechnicalData(row.row) ? 'outline-danger' : 'outline-' + Variant"
                        class="btn-circle border-0">
                        <font-awesome-icon icon="fa-solid fa-screwdriver-wrench" />
                    </b-button>
                    <!-- BOUTON TELECHARGEMENT MANDAT PDF -->
                     <b-button 
                        v-if="row.row.Status >= certificateStateEnum.Created && hasClientSignature(row.row.Distributor)"
                        @click="OnDownLoad(row.row)" 
                        v-b-tooltip.html
                        :title="$t('DownloadCertificate')"
                        :variant="'outline-' + Variant" 
                        class="btn-circle border-0">
                        <font-awesome-icon icon="fa-solid fa-download" />
                     </b-button>
                </template>
            </GenericTable>
        </template>
    </b-card>
</template>
<script lang="ts">
    /**
     * Composants Vue JS
     */
    import { Component, InjectReactive, PropSync, Vue } from 'vue-property-decorator';
    import { Getter } from 'vuex-class';    
    import { mixins } from 'vue-class-component';

    /**
     * Classes et énumérations
     */
    import { SMACertificate } from '@/types/Administration/SMA/SMACertificate';
    import { SMADistributorForm } from '@/types/Administration/SMA/SMADistributorForm';
    import CertificateStateEnum from '@/enums/Administration/SMA/CertificateStateEnum';
    import SMACertificateEnum from '@/enums/Administration/SMA/SMACertificateEnum';
import SMALifecycleStepEnum from '@/enums/Administration/SMA/SMALifecycleStepEnum';

    /**
     * Traduction
     */
    import locale from '../locales/SMA.json';

    /**
     * Classes et énumérations du tableau générique
     */
    import { SelectionTypeEnum } from '@/components/commons/Generics/GenericTable/GenericTableEnums';
    import {HeaderCustom, HeaderIcon, HeaderString, IconType, IHeader} from "@/components/commons/Generics/GenericTable/GenericTableHeader";

    /**
     * Composants tableau générique
     */
    import GenericTable, { CssClass } from '@/components/commons/Generics/GenericTable.vue';

    /**
     * Classe utilitaire
     */
    import Dictionary from '@/types/Dictionary';

    /**
     * Utilitaire
     */
    import { SMAUtils } from './SMAUtils';
    
    @Component({
        components: {
            GenericTable
        },
        i18n: {	messages: locale }
    })
    /**
     * Composant d'affichage de la liste des mandats
     */
    export default class CertificateList extends mixins(Vue, SMAUtils) {

        //#region Tableau des mandats

        /**
         * Types d'étapes de validation du cycle de vie d'un mandat décrites par le serveur
         */
        public lifecycleStepEnum = SMALifecycleStepEnum;

        /**
         * L'utilisateur est superviseur ou non
         */
        @Getter("SessionStore/GetUserIsSupervisor")
        public isSupervisor!: boolean;

        /**
         * Liste des formulaires distributeurs
         */
        @Getter('CertificateStore/GetForms')
        public forms!: Dictionary<SMADistributorForm>;

        /** 
         * Variant de couleur à appliquer sur le composant 
         */
        @InjectReactive()
        public Variant!: string;

        /**
         * Liste des mandats à afficher dans le tableau, passé en props par le composant parent
         */
        @PropSync('Items', { default: () => [] })
        public items!: Array<SMACertificate>;

        /**
         * En tête du tableau générique
         */
        private headers:  IHeader[] = [
            new HeaderCustom('Archive', this.$t('Archive').toString(), {Sort: false, ShowLabel: false, CssClasses : [new CssClass({CssClass: 'text-center'})]}),
            new HeaderIcon('Distributor', this.$t('Distributor').toString(), {Sort: true, CssClasses : [new CssClass({CssClass: 'text-center'})], IconType: IconType.Path}),
            new HeaderString('CertificateName', this.$t('CertificateName').toString(), {Sort: true, CssClasses : [new CssClass({CssClass: 'text-center'})]}),
            new HeaderCustom('DateValidation', this.$t('StartDate').toString(), {Sort: true, CssClasses : [new CssClass({CssClass: 'text-center'})]}),
            new HeaderCustom('EndDate', this.$t('EndDate').toString(), {Sort: true, CssClasses : [new CssClass({CssClass: 'text-center'})]}),
            new HeaderCustom('Status', this.$t('Status').toString(), {Sort: true, CssClasses : [new CssClass({CssClass: 'text-center'})]}),
            new HeaderCustom('Action', this.$t('Actions').toString(), {Sort: false, ShowLabel: true, CssClasses : [new CssClass({CssClass: 'text-center'})]}),
            new HeaderCustom('MeterInformations.Meters', this.$t('Actions').toString(), { Sort: false, ShowLabel: false, CssClasses : [new CssClass({CssClass: 'text-center'})], ShowColumn : false})
        ]

        /**
         * Variant de couleur du badge pour présenter le statut du mandat
         */
        private statusVariant: Dictionary<any> = {
            [CertificateStateEnum.Created]: 'warning',
            [CertificateStateEnum.ClientValidated]: 'primary',
            [CertificateStateEnum.SupervisorValidated]: 'success',
            [CertificateStateEnum.Archived]: 'quartary'
        };

        /**
         * Enumérations du tableau générique
         */
        private selectionTypeEnum = SelectionTypeEnum;

        /**
         * Enumérations des mandats
         */
        private certificateStateEnum = CertificateStateEnum;
        private sMACertificateEnum = SMACertificateEnum;

        /**
         * Formatage de la date de fin du mandat
         * @param date Date
         */
        private formatDate(date: Date): string {
            return date.toLocaleDateString('fr-FR', {
                day: '2-digit',
                month: 'long',
                year: 'numeric'
            });
        }

        /**
         * Formatage de la date de fin du mandat
         * @param string Date
         */
        private formatDateFromString(dateString: string): string {
            const date = new Date(dateString);

            if (isNaN(date.getTime())) {
                return '';
            }

            return date.toLocaleDateString('fr-FR', {
                day: '2-digit',
                month: 'long',
                year: 'numeric'
            });
        }

        //#endregion

        /**
         * Retourne l'url du logo du distributeur : en svg si disponible, sinon en webp
         * @param name Nom du distributeur
         */
        private getLogo(name: string) : string
        {
            try
            {
                return require(`@/assets/images/${name}.svg`);
            }
            catch
            {
                return require(`@/assets/images/${name}.webp`);
            }
        }

        //#region Actions sur mandats
        
        /**
         * Archivage d'un mandat
         * @param item Mandat à archiver
         */
        private OnArchive(item: SMACertificate): void{
            this.showBoxConfirm(this.$t('PleaseConfirm').toString(), this.Variant, 'ArchiveConfirm').then((value) => 
            {
                if(value)
                    this.$emit('OnArchive', item);
            });
        }

        /**
         * Lors de la suppression d'un mandat
         * @param item Mandat à supprimer
         */
        private OnDelete(item: SMACertificate): void{ 
            this.showBoxConfirm(this.$t('PleaseConfirm').toString(), this.Variant, 'DeleteCertificateConfirm').then((value) => 
            {
                if(value)
                    this.$emit('OnDelete', item);
            });
        }

        /**
         * Lors de la selection d'un mandat
         * @param item Mandat selectionné
         */
        private OnSelect(item: SMACertificate): void{
            this.$emit('OnSelect', item);
        }

        /**
         * Retour en arrière sur l'avancement du mandat
         * Si le mandat est au status Validation client ou Validation superviseur, le renvoi au status de création
         * @param item Mandat selectionné
         */
        private OnRollBack(item: SMACertificate): void{
            this.showBoxConfirm(this.$t('PleaseConfirm').toString(), this.Variant, 'RollBackConfirm').then((value) => 
            {
                if(value)
                    this.$emit('OnRollBack', item);
            });
        }

        /**
         * Lors de la modification d'un mandat
         * @param item Mandat selectionné
         */
        private OnEdit(item: SMACertificate): void{
            this.$emit('OnEdit', item);
        }

        /**
         * Ouverture de la fenête de signature du mandat
         * @param item Mandat à signer
         */
        private OnClientValidation(item: SMACertificate): void{
            this.$emit('OnClientValidation', item);
        }

        /**
         * Ouverture de la fenêtre de signature du mandat
         * @param item Mandat à signer
         */
        private OnSupervisorValidation(item: SMACertificate): void{
            this.$emit('OnSupervisorValidation', item);
        }

        /**
         * Lors du téléchargement du mandat
         * @param item Mandat
         */
        private OnDownLoad(item: SMACertificate): void{
            this.$emit('OnDownLoad', item);
        }

        /**
         * Ouverture de la FAQ
         */
        private OnShowFaq(): void{
            this.$emit('OnShowFaq');
        }

        /**
         * Indique si le distributeur du mandat dispose d'une saisie de données techniques des compteurs
         * @param distributor Type distributeur du mandat
         */
        private hasTechnicalData(distributor: number) : boolean
        {
            return this.forms[distributor]?.EnableTechnicalData ?? false;
        }

        /**
         * Indique si le cycle de vie du mandat du distributeur comporte une signature client (mandat PDF)
         * Décrit côté serveur dans SMAAttribute (LifecycleSteps)
         * @param distributor Type distributeur du mandat
         */
        private hasClientSignature(distributor: number) : boolean
        {
            return this.forms[distributor]?.LifecycleSteps?.includes(SMALifecycleStepEnum.ClientValidation) ?? true;
        }

        /**
         * Etat du mandat à partir duquel la validation superviseur est possible
         * Dernière étape de validation déclarée avant la validation superviseur dans le cycle de vie :
         * signature client (ClientValidated) si présente, sinon l'état de création
         * @param distributor Type distributeur du mandat
         */
        private supervisorValidationState(distributor: number) : number
        {
            return this.hasClientSignature(distributor) ? this.certificateStateEnum.ClientValidated : this.certificateStateEnum.Created;
        }

        /**
         * Indique si au moins un compteur du mandat n'a pas ses données techniques complètes
         * (point courant sans segment ou sans formule tarifaire, ou pas de point du tout)
         * @param certificate Mandat
         */
        private hasMissingTechnicalData(certificate: SMACertificate): boolean
        {
            return (certificate.MeterInformations?.Meters ?? []).some(meter => {
                const currentPoint = meter.TechnicalData?.History?.[0];

                return !currentPoint
                    || !currentPoint.DonneesGenerales?.Segment?.Code
                    || !currentPoint.SituationContractuelle?.StructureTarifaire?.FormuleTarifaireAcheminement?.Code;
            });
        }

        /**
         * Ouverture de la fenêtre de saisie des données techniques des compteurs
         * @param item Mandat selectionné
         */
        private OnTechnicalData(item: SMACertificate): void{
            this.$emit('OnTechnicalData', item);
        }

        //#endregion
    }
</script>
<style scoped>
</style>
